import { ClimbStandingIcon } from '../climbs/ClimbStandingIcon';
import { ClimbTile } from '../climbs/ClimbTile';
import type { Send } from '../../types/send';

interface SendTileProps {
  send: Send;
  /** History state the climb's page is opened with (see profile-origin). */
  linkState?: unknown;
}

/**
 * One send of the profile's grid: the climb's tile (see ClimbTile), with how
 * it was sent in the top right corner.
 */
export function SendTile({ send, linkState }: SendTileProps) {
  const { climb, send_type } = send.attributes;

  return (
    <ClimbTile
      climb={climb}
      linkState={linkState}
      testId="send-tile"
      // How it went — on sight, flash, or worked — in the same glyph the climb
      // rows use for the reader's own standing. Here it is this climber's, and
      // every tile is a send, so it is never hidden.
      corner={<ClimbStandingIcon climb={{ user_topped: true, user_send_type: send_type }} className="h-4 w-4" />}
    />
  );
}
